import { render } from "./SuggestionsModal.vue?vue&type=template&id=683009b2&scoped=true"
import script from "./SuggestionsModal.vue?vue&type=script&lang=js"
export * from "./SuggestionsModal.vue?vue&type=script&lang=js"

import "./SuggestionsModal.vue?vue&type=style&index=0&id=683009b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683009b2"]])

export default __exports__